// Team dropdown options cache — mirrors the existing city-options cache
// pattern (saveCityOptions/loadCityOptions in Hooks/useOfflineHousehold.js):
// single-record store, same createDatabase/storeDataInIndexedDB/
// fetchDataFromIndexedDB helpers, cleared on logout identically. Kept as its
// own Dexie database (not folded into cityOptionsDB) because a team list is
// only ever valid within the tenant it was fetched for, so the cached record
// is keyed by tenantId and must be invalidated independently of city options
// when the active tenant changes.
import {
  createDatabase,
  storeDataInIndexedDB,
  fetchDataFromIndexedDB,
  deleteDataFromIndexedDB,
} from "../Hooks/IndexedDBUtils";

export const teamOptionsDB = createDatabase("teamOptionsDB", "teamOptionsStore");

export const saveTeamOptions = (tenantId, options) => {
  return storeDataInIndexedDB(teamOptionsDB, "teamOptionsStore", {
    id: "teams",
    tenantId,
    options,
  });
};

export const loadTeamOptions = async (tenantId) => {
  const all = await fetchDataFromIndexedDB(teamOptionsDB, "teamOptionsStore");
  const found = Array.isArray(all) ? all.find((t) => t.id === "teams") : null;
  if (!found) return [];
  // Cached under a different tenant than the one currently active — treat as
  // a cache miss rather than returning another tenant's teams.
  if (found.tenantId !== tenantId) return [];
  return found.options || [];
};

export const clearTeamOptions = () => {
  return deleteDataFromIndexedDB(teamOptionsDB, "teamOptionsStore");
};
